import { Card, Loading, Text, View } from '@acin/ui-core';
import styled, { css } from 'styled-components';

export const ObligationsList = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;

export const FiltersHeader = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(4)};
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  position: relative;
  padding-bottom: ${(p) => p.theme.spacing.getSize(20)};
`;

export const FragmentItem = styled(View)<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(4)};
  padding: ${(p) => p.theme.spacing.getSize(3)} ${(p) => p.theme.spacing.getSize(4)};
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  position: relative;
  cursor: pointer;

  ${(p) =>
    p.isActive &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 16px;
        bottom: 16px;
        width: 4px;
        background: ${p.theme.colors.primary.getValue(700).main};
        border-radius: 4px;
      }
    `}
`;

export const FragmentTitle = styled(Text)`
  font-weight: 600;
  margin-bottom: ${(p) => p.theme.spacing.getSize(2)};
`;

export const ObligationContent = styled(View)`
  margin-left: ${(p) => p.theme.spacing.getSize(2)};
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(2)};
  flex: 1;
`;

export const ObligationTitle = styled(Text)`
  flex: 1;
  word-break: break-word;
  white-space: normal;
`;

export const Sentinel = styled.div`
  height: ${(p) => p.theme.spacing.getSize(5)};
  visibility: hidden;
`;

export const LoadingIndicator = styled(Loading)`
  display: block;
  margin: ${(p) => p.theme.spacing.getSize(3)};
`;

export const ObligationCard = styled(Card)<{ isActive?: boolean }>`
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.getSize()};
  padding: ${(p) => p.theme.spacing.getSize(3)} ${(p) => p.theme.spacing.getSize(2)};
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing.getSize()};
  align-items: flex-start;
  line-height: 1.5em;
  cursor: pointer;
  font-size: ${(p) => p.theme.type.getSize()};

  ${(p) =>
    p.isActive &&
    css`
      background: ${p.theme.colors.primary.getValue(100).main};
      border-color: ${p.theme.colors.primary.getValue(700).main};
    `}
`;

export const AlertContainer = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(4)};
`;
